<template>
  <DefaultHeader>
    <img
      class='lr-logo'
      src="../assets/logo.svg"
      alt="Lloyd's Register"
    />
  </DefaultHeader>
</template>


<script>
import DefaultHeader from '../../../src/views/HeaderFyF';

export default {
  components: {
    DefaultHeader,
  },
};
</script>

<style lang='scss'>

.lr-logo {
  margin: 24px 0;
  height: 70px;
  @media (max-width: 500px) {
    height: 50px;
    margin: 7px 0;
  }
}

</style>
